export default __webpack_public_path__ + "static/media/fill.f007ed9a.svg";